var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "edit-form__item" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "attributes",
            rawName: "v-attributes",
            value: "wrapper",
            expression: "'wrapper'",
          },
        ],
        staticClass: "wc-checklist",
        class: _vm.schema.style ? _vm.schema.style : "matrix",
        attrs: {
          disabled:
            typeof _vm.schema.disabled == "function"
              ? _vm.schema.disabled(_vm.model)
              : _vm.schema.disabled,
          visible:
            typeof _vm.schema.visible == "function"
              ? _vm.schema.visible(_vm.model)
              : _vm.schema.visible,
        },
      },
      _vm._l(_vm.items, function (item, index) {
        return _c(
          "wc-field",
          {
            key: index,
            staticClass: "wc-checkbox",
            attrs: {
              label: _vm.getItemName(item),
              disabled:
                typeof _vm.schema.disabled == "function"
                  ? _vm.schema.disabled(_vm.model)
                  : _vm.schema.disabled,
              position: "right",
            },
          },
          [
            _c("wc-checkbox", {
              class: _vm.schema.fieldClasses,
              attrs: {
                id: _vm.getFieldID(_vm.schema),
                type: "checkbox",
                status: _vm.isItemChecked(item) ? "checked" : "unchecked",
                checked: _vm.isItemChecked(item),
                disabled:
                  typeof _vm.schema.disabled == "function"
                    ? _vm.schema.disabled(_vm.model)
                    : _vm.schema.disabled,
                visible:
                  typeof _vm.schema.visible == "function"
                    ? _vm.schema.visible(_vm.model)
                    : _vm.schema.visible,
                error: _vm.inputError || _vm.errors.length !== 0,
                autocomplete: _vm.schema.autocomplete,
                name: _vm.schema.inputName,
                required: _vm.schema.required,
              },
              on: {
                change: function ($event) {
                  return _vm.onChanged($event, item)
                },
              },
            }),
          ],
          1
        )
      }),
      1
    ),
    _vm.errorMessage
      ? _c(
          "span",
          { staticClass: "error-message" },
          [
            _c("icon", { attrs: { icon: "status-error" } }),
            _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }